export const DESKTOP_BREAKPOINT = 1232;
export const MOBILE_BREAKPOINT = 616;
export const TOP_NAV_HEIGHT = 64;
export const LEFT_NAV_WIDTH = 256;

export const MOBILE_MEDIA_QUERY = `@media (max-width: ${
  MOBILE_BREAKPOINT - 1
}px)`;
export const NON_MOBILE_MEDIA_QUERY = `@media (min-width: ${MOBILE_BREAKPOINT}px)`;
export const TABLET_MEDIA_QUERY = `@media (max-width: ${
  DESKTOP_BREAKPOINT - 1
}px)`;
export const DESKTOP_MEDIA_QUERY = `@media (min-width: ${DESKTOP_BREAKPOINT}px)`;

export const LEFT_BAR_EXPANDED_WIDTH = LEFT_NAV_WIDTH;
export const LEFT_BAR_COLLAPSED_WIDTH = 56;
export const LEFT_BAR_SPINE_WIDTH = 68;

export const ANIMATION_DURATION_MS = 240;

export const ContentGutter = {
  DESKTOP: 48,
  MOBILE: 24,
};

// Provides a way to adjust legacy breakpoints upward to account for added
// left-nav and gutter width.
export const BREAKPOINT_ADJUSTMENT =
  LEFT_BAR_SPINE_WIDTH + ContentGutter.DESKTOP * 2;

export const withDesktopContentGutter = `
  padding-right: ${ContentGutter.DESKTOP}px;
  padding-left: ${ContentGutter.DESKTOP}px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const withMobileContentGutter = `
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding-right: ${ContentGutter.MOBILE}px;
    padding-left: ${ContentGutter.MOBILE}px;
  }
`;

/**
 * Usage:
 * const Container = styled.div`
 *   ${withContentGutter}
 * `;
 */
export const withContentGutter = `
  padding-right: ${ContentGutter.DESKTOP}px;
  padding-left: ${ContentGutter.DESKTOP}px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding-right: ${ContentGutter.MOBILE}px;
    padding-left: ${ContentGutter.MOBILE}px;
  }
`;
